import script from "./Registration.vue?vue&type=script&setup=true&lang=js"
export * from "./Registration.vue?vue&type=script&setup=true&lang=js"

import "./Registration.vue?vue&type=style&index=0&id=2a05fb09&lang=scss"
import "./Registration.vue?vue&type=style&index=1&id=2a05fb09&lang=scss&scoped=true"

import exportComponent from "E:\\xm\\siggraph\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a05fb09"]])

export default __exports__